module.exports = __webpack_public_path__ + "img/pineapple-bread-pudding.1a8bb7f8.jpg";